<template>
    <el-form ref="itemgroup" :model="groupdata" :label-position="labelPosition" inline class="item-group align-left">
        <el-form-item class="item" :prop="item.prop" v-for="(item, index) in groupColumns" :key="index">
            <span slot="label" :class="{ 'item-label': true, 'line-height20': labelPosition != 'top' && charLength(item.label) > 8 }">{{ (item.label && item.label.content) || item.label }}</span>
            <item-input
                :type="item.type"
                v-model="groupdata[item.prop]"
                :style="{ width: itemWith(item) + 'px' }"
                :readonly="filter_readonly(item)"
                v-bind="item.config"
                :options="filter_option(item)"
                :placeholder="item.placeholder"
                @input="valueChange(item)"
                :clearable="true"
            ></item-input>
        </el-form-item>
    </el-form>
</template>

<script>
export default {
    name: `ItemGroup`,
    props: {
        columns: { type: Array, required: true },
        data: { type: Object },
        labelPosition: {
            type: String,
            validator: function(t) {
                return t === `top` || t === `left` || t === `right`
            },
            default: `left`
        }
    },
    data() {
        return {
            width: 0,
            groupdata: {}
        }
    },
    mounted() {},
    computed: {
        groupColumns() {
            let that = this
            let newcs = this.columns.map(function(value, index, array) {
                that.$set(
                    that.groupdata,
                    value.prop,
                    that.data && _.isBoolean(that.data[value.prop]) ? that.data[value.prop] : !that.data || that.data[value.prop] == undefined ? value.default : that.data[value.prop]
                ) // 解决 bool类型赋值
                // that.$set(that.groupdata, value.prop, _.isBoolean(value.default)?value.default:'' )
                return _.cloneDeep(value)
            })
            return newcs
        }
    },
    methods: {
        filter_readonly(column) {
            let that = this
            if (column.readonly && _.isFunction(column.readonly)) {
                return column.readonly(this, { row: that.groupdata, column, area: `itemgroup` })
            }
            return column.readonly
        },
        valueChange(column) {
            // 触发change事件
            let r = { ...this.groupdata }
            this.$emit(`change`, r)
        },
        filter_option(item) {
            if (item.options && _.isFunction(item.options)) {
                return item.options(this, { row: { ...this.groupdata }, column: item, area: `query` })
            }
            return item.options
        },
        charLength(str) {
            // 先把中文替换成两个字节的英文，在计算长度
            return ((str && str.content) || str || ``).replace(/[\u0391-\uFFE5]/g, `aa`).length
        },
        itemWith(item) {
            return item.options ? Math.max(item.width || 120, 120) : item.width || 120
        }
    }
}
</script>

<style scoped lang="less">
.item {
    padding: 0 5px 0 0;
    margin: 0;
}
</style>
<style lang="less">
.item-group {
    .el-form-item {
        .el-form-item__label {
            width: unset !important;
        }
        .el-form-item__content {
            margin-left: 0 !important;
        }
    }
    &.el-form--label-top {
        .el-form-item__label {
            line-height: 24px;
            margin: 0;
            padding: 0;
        }
    }
    .el-form-item__label {
        line-height: 38px;
    }
}
</style>



// WEBPACK FOOTER //
// src/common/ItemGroup.vue